module.exports = __webpack_public_path__ + "static/media/012.f777e580.jpg";